module.exports = __webpack_public_path__ + "img/032.d2b2a345.png";